(function () {
  'use strict';

  function patchSelects() {
    document.querySelectorAll('select').forEach(function (sel) {
      if (!sel.options[0]) return;
      var first = sel.options[0].text.trim();
      if (first === '-- Select a genre --' && !sel.getAttribute('aria-label')) {
        sel.setAttribute('aria-label', 'GENRE');
        sel.setAttribute('name', 'properties[GENRE]');
      }
      if (first === '-- Select a vocal style --' && !sel.getAttribute('aria-label')) {
        sel.setAttribute('aria-label', 'VOCAL STYLE');
        sel.setAttribute('name', 'properties[VOCAL STYLE]');
      }
    });
  }

  var REQUIRED = {
    'custom-song-your-story-your-music': [
      { label: 'genre',              ph: '-- Select a genre --',        msg: 'Please select a genre' },
      { label: 'song mood',          ph: '-- Select a mood --',         msg: 'Please select a song mood' },
      { label: 'vocal style',        ph: '-- Select a vocal style --',  msg: 'Please select a vocal style' },
      { label: 'song language',      ph: '-- Select a language --',     msg: 'Please select a song language' },
      { label: 'who is this song',   ph: '',                            msg: 'Please enter the name' },
      { label: 'relationship',       ph: '',                            msg: 'Please describe your relationship' },
      { label: 'the occasion is',    ph: '-- Select an occasion --',    msg: 'Please select an occasion' },
      { label: 'your email address', ph: '',                            msg: 'Please enter your email', email: true }
    ],
    'create-beats': [
      { label: 'genre',                              ph: '-- Select a genre --',       msg: 'Please select a genre' },
      { label: 'song mood',                          ph: '-- Select a mood --',        msg: 'Please select a song mood' },
      { label: 'vocal style',                        ph: '-- Select a vocal style --', msg: 'Please select a vocal style' },
      { label: 'choose the language for your album', ph: '-- Select a language --',    msg: 'Please select your album language' },
      { label: 'your email address',                 ph: '',                           msg: 'Please enter your email', email: true }
    ]
  };

  function getHandle() {
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function init() {
    var handle = getHandle();
    if (!handle || !REQUIRED[handle]) return;

    patchSelects();

    var form   = document.querySelector('form[action*="/cart/add"]');
    var addBtn = document.querySelector('button[name="add"]');

    // Ако и двете липсват — изчакай
    if (!form && !addBtn) { setTimeout(init, 500); return; }

    // Custom Song: стандартен form submit
    if (form && !form._k) {
      form._k = true;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        patchSelects();
        clearErrors();
        var errors = validate(REQUIRED[handle]);
        if (errors.length > 0) { errors[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        var btn = form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]');
        doAdd(form, btn, handle);
      }, true);
    }

    // Ambient: бутонът е в HTML блок — директен click listener
    if (addBtn && !addBtn._k) {
      addBtn._k = true;
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        patchSelects();
        clearErrors();
        var errors = validate(REQUIRED[handle]);
        if (errors.length > 0) { errors[0].scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        doAdd(form, addBtn, handle);
      }, true);
    }
  }

  function findByLabel(fragment) {
    var f = fragment.toLowerCase();
    var els = document.querySelectorAll('input, select, textarea');
    for (var i = 0; i < els.length; i++) {
      var lbl = (els[i].getAttribute('aria-label') || '').toLowerCase();
      if (lbl === 'enter your email') continue;
      if (lbl.indexOf(f) >= 0) return els[i];
    }
    return null;
  }

  function validate(required) {
    var errors = [];
    required.forEach(function (cfg) {
      var el = findByLabel(cfg.label);
      if (!el) return;
      var val = (el.value || '').trim();
      if (!val || val === cfg.ph || val.startsWith('-- ')) {
        markError(el, cfg.msg);
        errors.push(el);
        return;
      }
      if (cfg.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
        markError(el, 'Please enter a valid email (e.g. name@email.com)');
        if (errors.indexOf(el) < 0) errors.push(el);
      }
    });
    return errors;
  }

  function doAdd(form, btn, handle) {
    var varInput = form ? form.querySelector('input[name="id"]') : null;
    var varId = varInput ? varInput.value : null;
    if (!varId) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var id = p.variants && p.variants[0] && p.variants[0].id;
          if (id) sendToCart(form, btn, id);
          else showGlobalError(form, btn, 'Product not found. Please refresh.');
        })
        .catch(function () { showGlobalError(form, btn, 'Connection error. Please try again.'); });
    } else {
      sendToCart(form, btn, varId);
    }
  }

  function sendToCart(form, btn, varId) {
    var props = {};
    document.querySelectorAll('input, select, textarea').forEach(function (el) {
      var ariaLbl = (el.getAttribute('aria-label') || '').toLowerCase();
      if (ariaLbl === 'enter your email') return;
      if (el.closest && el.closest('footer')) return;
      var name = el.getAttribute('name') || '';
      var key = '';
      if (name.indexOf('properties[') === 0) {
        key = name.slice(11, -1);
      } else if (el.getAttribute('aria-label')) {
        key = (el.getAttribute('aria-label') || '').replace(/[*📧🌍🎵🎉💌🏛️]/g, '').trim();
      }
      if (!key) return;
      var val = (el.value || '').trim();
      if (!val || val.startsWith('-- ') || val === key) return;
      props[key] = val;
    });

    var origText = btn ? btn.textContent.trim() : 'ADD TO CART';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(varId, 10), quantity: 1, properties: props })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    })
    .then(function () {
      if (btn) {
        btn.textContent = '✓ Added!';
        btn.style.setProperty('background', '#1a6b1a', 'important');
        btn.style.setProperty('color', '#fff', 'important');
      }
      setTimeout(function () { window.location.href = '/cart'; }, 1000);
    })
    .catch(function (err) {
      if (btn) { btn.disabled = false; btn.textContent = origText; btn.style.removeProperty('background'); btn.style.removeProperty('color'); }
      var msg = err && err.description ? err.description : 'Error adding to cart. Please try again.';
      showGlobalError(form, btn, msg);
    });
  }

  function markError(el, msg) {
    el.style.setProperty('border', '2px solid #e53e3e', 'important');
    el.style.setProperty('background-color', '#fff5f5', 'important');
    el.style.setProperty('box-shadow', '0 0 0 3px rgba(229,62,62,0.25)', 'important');
    var parent = el.parentElement;
    if (!parent.querySelector('.k-err')) {
      var p = document.createElement('p');
      p.className = 'k-err';
      p.style.cssText = 'color:#e53e3e;font-size:13px;font-weight:700;margin:5px 0 0;';
      p.textContent = '⚠ ' + msg;
      parent.appendChild(p);
    }
    function clear() {
      el.style.removeProperty('border');
      el.style.removeProperty('background-color');
      el.style.removeProperty('box-shadow');
      var err = parent.querySelector('.k-err');
      if (err) err.remove();
    }
    el.addEventListener('change', clear, { once: true });
    el.addEventListener('input',  clear, { once: true });
  }

  function clearErrors() {
    document.querySelectorAll('.k-err, .k-global-err').forEach(function (e) { e.remove(); });
    document.querySelectorAll('input, select, textarea').forEach(function (el) {
      el.style.removeProperty('border');
      el.style.removeProperty('background-color');
      el.style.removeProperty('box-shadow');
    });
  }

  function showGlobalError(form, btn, msg) {
    var div = document.createElement('div');
    div.className = 'k-global-err';
    div.style.cssText = 'background:#fff5f5;border:2px solid #e53e3e;color:#c53030;padding:12px 16px;border-radius:8px;margin:10px 0;font-size:14px;font-weight:600;';
    div.textContent = '⚠ ' + msg;
    var target = btn || (form && (form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]')));
    if (target) target.insertAdjacentElement('beforebegin', div);
    else if (form) form.appendChild(div);
    else document.body.appendChild(div);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 400); });
  } else {
    setTimeout(init, 400);
  }

})();